import { useDebounce, useDebouncedCallback } from 'use-debounce'

/**
 * Reexport of https://github.com/xnimorz/use-debounce
 */
export { useDebouncedCallback, useDebounce }
